import React from 'react';
import { Route, Switch } from 'react-router-dom';
import UserDetails from '../../../UserDetails/index';

export default () => (
  <Switch>
    <Route exact path="/viewuser" component={UserDetails} />
  </Switch>
);